

import { getItemMargin } from "widgets/commonComponents/base/multiImagesFrontScroller";
import { MultiImagesScrollPerItem } from "widgets/commonComponents/base/multiImagesScrollPerItem";
import { IFieldDisplayData, VideoSettingsData } from "widgets/commonDataObjects/interfaces";
import { SiteItemData } from "widgets/interfaces";
import { googleScript } from "../../../../widgetsUtils";
import { MultiImagesItemFront } from "./frontItem";

interface MultiImagesFrontProps {
    itemList: SiteItemData[]
    width: number
    fieldsDisplaySettings: IFieldDisplayData
    videoSettings: VideoSettingsData
    imageWidth: number
    imageHeight: number
    onRowDisplay: boolean
    titleColor: string
    isYplusComp?: boolean
    isLTR?: boolean
    isImageOnly?: boolean
    ads_infrastructure_type?: string
    includeAudioPlayer?: boolean
    siteName?: string
    itemColor?: string
    shouldRedirectToArticle?:boolean
    shouldDisplayCategoryIcon?: boolean
    isHiddenHourInYesterday?:boolean
}

export class MultiImages1280Front extends React.Component<MultiImagesFrontProps>{
    public static siteScriptName = "MultiImages1280Front";

    public render() {
        const { shouldDisplayCategoryIcon, shouldRedirectToArticle, itemColor, imageWidth, itemList, imageHeight, videoSettings, fieldsDisplaySettings, width, onRowDisplay, titleColor, isYplusComp, isLTR, isImageOnly, ads_infrastructure_type, includeAudioPlayer, siteName, isHiddenHourInYesterday } = this.props
        const itemStyle = { marginInlineEnd: getItemMargin(width, imageWidth) }

        if (onRowDisplay) return (
            <MultiImagesScrollPerItem imageWidth={imageWidth} width={width} itemLength={itemList.length} isLTR={isLTR} marginRight={getItemMargin(width, imageWidth)} >
                {itemList.map((slot, index) => {
                    if (slot.isDFP) return (
                        <div id={slot.dfpId} key={index} className={`slotView dfpId ${slot.isCommertial ? "commertialStyle" : ""}`} style={itemStyle}>
                            {ads_infrastructure_type && ads_infrastructure_type === "new" && <script type="text/javascript" dangerouslySetInnerHTML={{ __html: googleScript(slot.dfpId) }}></script>}
                        </div>
                    )
                    else return (
                        <MultiImagesItemFront
                            imageWidth={imageWidth}
                            key={index}
                            imageHeight={imageHeight}
                            videoSettings={videoSettings}
                            fieldsDisplaySettings={fieldsDisplaySettings}
                            item={slot}
                            titleColor={titleColor}
                            margin={getItemMargin(width, imageWidth)}
                            onRowDisplay={onRowDisplay}
                            isYplusComp={isYplusComp}
                            isSmallItem={true}
                            isLTR={isLTR}
                            isImageOnly={isImageOnly}
                            includeAudioPlayer={includeAudioPlayer}
                            siteName={siteName}
                            itemColor={itemColor}
                            shouldRedirectToArticle={shouldRedirectToArticle}
                            shouldDisplayCategoryIcon={shouldDisplayCategoryIcon}
                            isHiddenHourInYesterday={isHiddenHourInYesterday}
                        />
                    )
                })}
            </MultiImagesScrollPerItem >
        )
        else return (
            <div className="slotsContent">
                {itemList.map((slot, index) => {
                    if (slot.isDFP) return (
                        <div id={slot.dfpId} key={index} className={`slotView dfpId ${slot.isCommertial ? "commertialStyle" : ""}`} style={{ margin: "0 10px 24px" }} >
                            {ads_infrastructure_type && ads_infrastructure_type === "new" && <script type="text/javascript" dangerouslySetInnerHTML={{ __html: googleScript(slot.dfpId) }}></script>}
                        </div>
                    )
                    else return (
                        <MultiImagesItemFront
                            imageWidth={imageWidth}
                            key={index}
                            imageHeight={imageHeight}
                            videoSettings={videoSettings}
                            fieldsDisplaySettings={fieldsDisplaySettings}
                            item={slot}
                            margin={getItemMargin(width, imageWidth)}
                            onRowDisplay={onRowDisplay}
                            titleColor={titleColor}
                            isYplusComp={isYplusComp}
                            isSmallItem={true}
                            isLTR={isLTR}
                            isImageOnly={isImageOnly}
                            includeAudioPlayer={includeAudioPlayer}
                            siteName={siteName}
                            itemColor={itemColor}
                            shouldRedirectToArticle={shouldRedirectToArticle}
                            shouldDisplayCategoryIcon={shouldDisplayCategoryIcon}
                            isHiddenHourInYesterday={isHiddenHourInYesterday}
                        />
                    )
                })}
            </div>
        )
    }
}